import { RouteN } from '../../routes-path';

export const goToLogin = () => {
    return RouteN.auth.route + '/' + RouteN.auth.children.login;
};

export const goToResetPassword = () => {
    return RouteN.auth.route + '/' + RouteN.auth.children.reset;
};
